export const formatDate = (dateString: string): string => {
	if (!dateString) return 'N/A';
	const date = new Date(dateString);
	return date.toLocaleString('en-IN', {
		year: 'numeric',
		month: 'short',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit'
	});
};

export const formatJson = (value: any): string => {
	if (value === null || value === undefined) return '';
	if (typeof value === 'string') {
		try {
			return JSON.stringify(JSON.parse(value), null, 2);
		} catch {
			return value;
		}
	}
	return JSON.stringify(value, null, 2);
};

export const truncateText = (text: string, maxLength: number = 80): string => {
	if (!text) return '';
	if (text.length <= maxLength) return text;
	return `${text.substring(0, maxLength)}...`;
};

export const capitalize = (str: string): string => {
	if (!str) return '';
	return str.charAt(0).toUpperCase() + str.slice(1);
};
